<template>
    <vc-date-picker
        v-bind="{ ...$attrs }"
        v-on="$listeners"
        mode="date"
        is-expanded
        title-position="left"
        trim-weeks
        :min-date="startDate"
        :max-date="endDate"
        :model-config="modelConfig"
        :select-attribute="selectAttribute"
    />
</template>

<script>
export default {
    name: 'SalonDatePicker',
    data: () => ({
        modelConfig: {
            type: 'string',
            mask: 'YYYY-MM-DD', // Uses 'iso' if missing
        },
        selectAttribute: {
            highlight: {
                color: 'orange',
                fillMode: 'solid',
                style: {
                    backgroundColor: '#FF9F48',
                },
            },
        },
    }),
    props: {
        startDate: {
            type: String,
        },
        endDate: {
            type: String,
        },
    },
    created() {
        // console.log("in datepicker",this.startDate,this.endDate)
    },
};
</script>

<style lang="scss" scoped></style>
